var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0607 47.5607C24.4749 48.1464 23.5251 48.1464 22.9393 47.5607L13.9393 38.5607C13.3536 37.9749 13.3536 37.0251 13.9393 36.4393L16.9393 33.4393C17.5251 32.8535 18.4749 32.8535 19.0607 33.4393L21 35.3787V12H3C1.34315 12 0 10.6569 0 9V3C0 1.34314 1.34315 0 3 0H45C46.6569 0 48 1.34314 48 3V9C48 10.6569 46.6569 12 45 12H27V35.3787L28.9393 33.4393C29.5251 32.8535 30.4749 32.8535 31.0607 33.4393L34.0607 36.4393C34.6464 37.0251 34.6464 37.9749 34.0607 38.5607L25.0607 47.5607Z",
    fill: "#1C2743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27C1.34315 27 0 25.6569 0 24V18C0 16.3431 1.34315 15 3 15H16.5C17.3284 15 18 15.6716 18 16.5C18 17.3284 17.3284 18 16.5 18H3V24H16.5C17.3284 24 18 24.6716 18 25.5C18 26.3284 17.3284 27 16.5 27H3Z",
    fill: "#1C2743"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 27C30.6716 27 30 26.3284 30 25.5C30 24.6716 30.6716 24 31.5 24H45V18H31.5C30.6716 18 30 17.3284 30 16.5C30 15.6716 30.6716 15 31.5 15H45C46.6569 15 48 16.3431 48 18V24C48 25.6569 46.6569 27 45 27H31.5Z",
    fill: "#1C2743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUnion);
export default __webpack_public_path__ + "static/media/ico-union.c77cac3b8d6c4a47e92654e39a130861.svg";
export { ForwardRef as ReactComponent };